module.exports = __webpack_public_path__ + "static/media/user.8bbf1475.svg";